<template>
  <div class="main">
    <div class="subject">
      <a-table
        :columns="columns"
        :dataSource="lists"
        :pagination="pagination"
        :rowKey="record => record.adid"
        :loading="loading"
        @change="handleTableChange"
        bordered
      >
        <template slot="title">
          <a-button @click="handle('add', {})">新增广告</a-button>
        </template>
        <template slot="linkurl" slot-scope="text">
          <a :href="text" target="_blank">{{ text }}</a>
        </template>
        <template slot="adimg" slot-scope="text">
          <img :src="text" class="thumbnail" />
        </template>
        <template slot="operation" slot-scope="text, record, index">
          <a @click="handle('edit', record)">编辑</a>
          <a-popconfirm
            title="确定要删除么？"
            okText="确定"
            cancelText="取消"
            @confirm="del(record, index)"
          >
            <a class="active">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <a-modal
      v-model="visible"
      :title="title"
      @ok="modifyExpert"
      :maskClosable="false"
      destroyOnClose
      width="1000px"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
    >
      <a-form :form="form" @submit="modifyExpert" style="height:720px">
        <div style="width:450px;display:inline-block">
          <a-form-item style="display:none">
            <a-input v-decorator="['adid']"></a-input>
          </a-form-item>
          <a-form-item
            label="广告图地址："
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-input
              :max-length="20"
              placeholder="请在下方上传图片"
              v-decorator="[
                'adimg',
                {
                  rules: [
                    {
                      required: true,
                      message: '开始时间必填'
                    }
                  ]
                }
              ]"
              disabled
            />
          </a-form-item>
          <a-form-item
            label="上线时间："
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-date-picker
              v-decorator="[
                'adstart',
                {
                  rules: [
                    {
                      type: 'object',
                      required: true,
                      message: '上线时间必填'
                    }
                  ]
                }
              ]"
              :disabledDate="advStartDate"
              showTime
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="上线时间"
              @openChange="startOpenChange"
            />
          </a-form-item>
          <a-form-item
            label="下线时间："
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
          >
            <a-date-picker
              v-decorator="[
                'adend',
                {
                  rules: [
                    {
                      type: 'object',
                      required: true,
                      message: '下线时间必填'
                    }
                  ]
                }
              ]"
              :disabledDate="advEndDate"
              showTime
              :open="endOpen"
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="下线时间"
              @openChange="endOpenChange"
            />
          </a-form-item>
          <a-form-item
            label="广告链接："
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 15 }"
            :max-length="200"
          >
            <a-input v-decorator="['linkurl']" />
          </a-form-item>
        </div>
        <div style="display:inline-block;float:right">
          <a-form-item label="上传图片">
            <a-upload-dragger
              name="file"
              accept="image/*"
              :headers="headers"
              :beforeUpload="beforeUpload"
              :showUploadList="false"
              class="avatar-uploader"
              v-decorator="['upload']"
            >
              <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
              <div ref="imgupload" v-else>
                <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  上传广告图
                </div>
              </div>
            </a-upload-dragger>
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'adid'
  },
  {
    title: '上线时间',
    dataIndex: 'adstart',
    align: 'center',
    scopedSlots: { customRender: 'adstart' }
  },
  {
    title: '下线时间',
    dataIndex: 'adend',
    scopedSlots: { customRender: 'adend' }
  },
  {
    title: '广告链接',
    dataIndex: 'linkurl',
    scopedSlots: { customRender: 'linkurl' },
    align: 'center'
  },
  {
    title: '缩略图',
    dataIndex: 'adimg',
    scopedSlots: { customRender: 'adimg' },
    align: 'center'
  },

  {
    title: '操作',
    dataIndex: 'operation',
    width: 200,
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
];
import moment from 'moment';
export default {
  data() {
    return {
      columns,
      param: {
        page: 1,
        limit: 20
      },
      area_id: JSON.parse(window.localStorage.getItem('siteinfo')).area_id,
      loading: false,
      pagination: {
        pageSize: 20
      },
      lists: [],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this, { name: 'modify' }),
      endOpen: false,
      headers: {
        //上传图片至云图库的请求头
        Authorization: window.localStorage.getItem('token')
      },
      imageUrl: '',
      uploadLoading: false,
      title: '新增广告'
    };
  },
  computed: {},
  watch: {},
  methods: {
    getList(param) {
      this.loading = true;
      this.$http.post('/api/app/adlist', param).then(res => {
        if (res.data.state == 200) {
          const pagination = { ...this.pagination };
          this.lists = res.data.data;
          pagination.total = res.data.pages * 20;
          this.lists = res.data.data;
          this.pagination = pagination;
        }
        this.loading = false;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = this.pagination.current;
      this.getList(this.param);
    },
    del(record) {
      this.$http.post('/api/app/addel', { ids: record.adid }).then(res => {
        if (res.data.state == 200) {
          this.$message.success('删除成功');
          this.param.page = 1;
          this.getList(this.param);
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    modifyExpert(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          let data = {
            adid: values.adid ? values.adid : '',
            adimg: values.adimg,
            adstart: moment(values.adstart, 'YYYY-MM-DD HH:mm:ss').format(
              'YYYY-MM-DD HH:mm:ss'
            ),
            adend: moment(values.adend, 'YYYY-MM-DD HH:mm:ss').format(
              'YYYY-MM-DD HH:mm:ss'
            ),
            linkurl: values.linkurl ? values.linkurl : '',
            area_id: this.area_id
          };
          this.$http.post('/api/app/adupdate', data).then(res => {
            this.confirmLoading = false;
            if (res.data.state == 200) {
              this.$message.success('添加成功');
              this.visible = false;
              this.getList(this.param);
            }
          });
        }
      });
    },
    advStartDate(startValue) {
      const endValue = this.form.getFieldValue('adend');
      if (startValue < moment().subtract(1, 'day')) {
        return true;
      }
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    advEndDate(endValue) {
      const startValue = this.form.getFieldValue('adstart');
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    startOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    endOpenChange(open) {
      this.endOpen = open;
    },
    async beforeUpload(file) {
      this.uploadLoading = true;
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.imageUrl = result.data.data;
        this.form.setFieldsValue({ adimg: result.data.data });
      } else {
        this.$$message.error('文件上传失败');
      }
      this.uploadLoading = false;
    },
    handle(type, record) {
      let that = this;
      that.visible = true;
      if (type == 'edit') {
        that.title = '编辑广告';
        that.$nextTick(() => {
          that.imageUrl = record.adimg;
          that.form.setFieldsValue({
            adid: record.adid ? record.adid : '',
            linkurl: record.linkurl,
            adstart: moment(record.adstart),
            adend: moment(record.adend),
            adimg: record.adimg
          });
        });
      } else {
        that.title = '新增广告';
        that.imageUrl = '';
        that.form.resetFields();
      }
    }
  },
  created() {
    this.param.area_id = this.area_id;
    this.getList(this.param);
  },
  mounted() {}
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
}
.subject {
  padding: 10px;
}
.thumbnail {
  width: 200px;
}
.active {
  color: #f00;
  margin-left: 5px;
}
.avatar-uploader >>> .ant-upload {
  width: 350px;
  height: 669px;
}
.avatar-uploader img {
  width: 350px;
  height: 667px;
}
</style>
